// @flow
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { confirmAlert } from "react-confirm-alert"; // For subscription alerts or error alerts
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import Tour from "reactour";

import { Page } from "tabler-react";
import { MapComponent, SiteWrapper } from "../../containers";
import { Newsticker, ModalComponent, TextBox } from "../index";
import "./style.css";
import "./guidedTour.css";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

import { mapActions, userActions } from "../../store/actions";

function Home(props) {
  const { setTourGuide, mapLoading } = props;
  // OPEN/CLOSE NIGHTLY ALERT MODAL
  const [drawingState, changeDrawingState] = useState(true);
  // GUIDED TOUR
  let tourGuide = !mapLoading ? setTourGuide : false;
  const [startGuide, stopGuide] = useState(tourGuide);
  // const [step, setStep] = useState(0);
  const accentColor = "linear-gradient(to right, #94A869, #94A869)";
  const disableBody = (target) => disableBodyScroll(target);
  const enableBody = (target) => enableBodyScroll(target);

  const steps = [
    // {
    //   selector: '[data-tut="site-logo"]',
    //   content: "Welcome to Whispering bell let's start the tour",
    //   position: "bottom",
    //   action: (node) => {
    //     // by using this, focus trap is temporary disabled
    //     node.focus();
    //     props.openFilterSidebar(true, true);
    //   },
    // },
    {
      selector: ".map-header",
      content: function DemoHelperComponent() {
        return (
          <div>
            Welcome to Whispering Bell’s platform. <br />
            You are currently viewing the <TextBox color="#e5e5e5">
              50{" "}
            </TextBox>{" "}
            most recent incidents on the map. Let’s begin the guided tour!
          </div>
        );
      },
      position: "bottom",
      action: (node) => {
        props.openFilterSidebar(true, true);
        // on timeout open side bar and then quickly redirect to next step
        setTimeout(() => {
          // props.openFilterSidebar(true, false);
        }, 1500);
        setTimeout(() => {
          // setStep(2);
        }, 1800);
      },
      closeWithMask: false,
      disableInteraction: false,
    },
    {
      selector: '[data-tut="mapFilterBtn"]',
      content: "Filters can be used to narrow down results",
      position: "bottom",
      action: (node) => {
        props.openFilterSidebar(true, true);
        // // on timeout open side bar and then quickly redirect to next step
        // setTimeout(() => {
        //   props.openFilterSidebar(true, false);
        // }, 1500);
        // setTimeout(() => {
        //   setStep(2);
        // }, 1800);
      },
    },
    // {
    //   selector: '[data-tut="filter-layer"]',
    //   content: function DemoHelperComponent() {
    //     return <div>Click here to view more incidents.</div>;
    //   },
    //   position: "bottom",
    //   action: (node) => {
    //     // props.openFilterSidebar(true, false);
    //   },
    // },
    // {
    //   selector: '[data-tut="sidebarBtn"]',
    //   content: "Or customize your preferences to filter more accurate results",
    //   position: "right",
    //   action: (node) => {
    //     props.openFilterSidebar(true, false);
    //     // by using this, focus trap is temporary disabled
    //     node.focus();
    //     props.openFilterSidebar(true, false);
    //   },
    // },
    {
      selector: '[data-tut="geo-fence"]',
      content:
        "You can now create & monitor your own geofence. You can opt to receive spot reports and alerts within your perimeter by clicking this button",
      position: "left",
      action: (node) => {
        // by using this, focus trap is temporary disabled
        node.focus();
        props.openFilterSidebar(true, true);
      },
    },
    {
      selector: ".leaflet-control-zoom",
      content: "Manage map zoom controls from here",
      position: "left",
      action: (node) => {
        // by using this, focus trap is temporary disabled
        node.focus();
        props.openFilterSidebar(true, true);
      },
    },
    {
      selector: '[data-tut="site-mygeofence"]',
      content: function DemoHelperComponent() {
        return (
          <div>
            Click <TextBox color="#e5e5e5">Geofencing </TextBox> to view, edit,
            delete, or zoom your geofences.
          </div>
        );
      },
      action: (node) => {
        // by using this, focus trap is temporary disabled
        props.openFilterSidebar(true, true);
      },
      position: "bottom",
    },
    {
      selector: '[data-tut="map-layers"]',
      content: "Click here to select different map layers",
      position: "left",
      action: (node) => {
        // by using this, focus trap is temporary disabled
        node.focus();
        props.openFilterSidebar(true, true);
      }
    },
    {
      selector: '[data-tut="legend-control"]',
      content: function DemoHelperComponent() {
        return (
          <div>
            {/* Color codes for <TextBox color="#e5e5e5">intensity </TextBox>.
            <br />
            Icons for <TextBox color="#e5e5e5">type of attack </TextBox>. */}
            View Map Legend
          </div>
        );
      },
      position: "left",
      action: (node) => {
        // by using this, focus trap is temporary disabled
        node.focus();
        props.openFilterSidebar(true, true);
      },
    },
    {
      selector: '[data-tut="ticker-control"]',
      content: "You can view the latest spot reports in the ticker below...",
      position: "top",
      action: (node) => {
        // by using this, focus trap is temporary disabled
        node.focus();
        props.openFilterSidebar(true, true);
      },
    },
    // {
    //   selector: '[data-tut="site-mygeofence"]',
    //   content: "Get in touch with us",
    //   action: (node) => {
    //     // by using this, focus trap is temporary disabled
    //     props.openFilterSidebar(true, true);
    //   },
    //   position: "bottom",
    // },
    {
      selector: ".map-header",
      content: "Now that you have viewed all the steps, lets get started!!",
      position: "bottom",
    },
  ];
  // Below mentioned use effect works life component will recieve props
  useEffect(() => {
    // CHANGE DRAWING STATE
    changeDrawingState(props.drawEnd);
    // DISPLAY ALERT FOT TYPE ALERT ERROR
    if (props.alert.type === "danger") {
      confirmAlert({
        message: props.alert.message,
        buttons: [
          {
            label: "Ok",
          },
        ],
      });
    }
    // CHANGE GUIDED TOUR STATE
    if (props.setTourGuide) {
      stopGuide(props.setTourGuide);
    }
  }, [props, setTourGuide]);

  // Below mentioned use effect works life component did mount
  useEffect(() => {
    let user = JSON.parse(localStorage.getItem("user"));
    let localTourGuide = JSON.parse(localStorage.getItem("localTourGuide"));
    let loginCount = user.login_count > 2 ? false : true;
    if (localTourGuide <= 2) {
      props.initGuidedTour(loginCount);
    } else {
      props.guidedTour(false);
    }
    stopGuide(loginCount);
  }, []);

  const closeTourGuide = () => {
    stopGuide(!startGuide);
    props.guidedTour(false);
  };

  return (
    <SiteWrapper>
      {drawingState === true ? <ModalComponent component="NightlyAlert" /> : ""}
      <Page.MapHeader>
        {setTourGuide && (
          <Tour
            onAfterOpen={disableBody}
            onBeforeClose={enableBody}
            onRequestClose={closeTourGuide}
            steps={steps}
            showButtons={true}
            updateDelay={1000}
            // goToStep={step}
            isOpen={startGuide}
            className="helper"
            rounded={5}
            accentColor={accentColor}
            closeWithMask={true}
            badgeContent={(curr, tot) => `${curr} / ${tot}`}
          />
        )}
        <MapComponent />
      </Page.MapHeader>
      <Newsticker />
    </SiteWrapper>
  );
}
function mapStateToProps(state) {
  const { alert } = state;
  const { drawEnd } = state.drawing;
  const { setTourGuide, localTourGuide } = state.user;
  const { mapLoading } = state.map;
  return {
    mapLoading,
    alert,
    drawEnd,
    setTourGuide,
    localTourGuide,
  };
}

const mapDispatchToProps = {
  openFilterSidebar: mapActions.openFilterSidebar,
  guidedTour: userActions.guidedTour,
  initGuidedTour: userActions.initGuidedTour,
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
